import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom as _fvf } from 'rxjs';
import { IService } from '../../../../core/interfaces/i.service.interface';
import { IResponse } from '../../../../core/interfaces/response.interface';
import { ILandingPost, ILandingPostCommentActivityPublic } from '../interface';

@Injectable({ providedIn: 'root' })
export class LandingPostService implements IService {
  _baseUrl = 'landing-post';
  constructor(private http: HttpClient) {}

  getDetails(landingId: string) {
    return _fvf(
      this.http.get<IResponse<ILandingPost>>(
        `${this._baseUrl}/details/${landingId}`,
        {},
      ),
    );
  }

  like(id: string, isQrCode: boolean) {
    return _fvf(
      this.http.put<IResponse<boolean>>(
        `${this._baseUrl}/like/${id}`,
        {},
        { params: { isSilent: true, isQrCode } },
      ),
    );
  }

  disLike(id: string, isQrCode: boolean) {
    return _fvf(
      this.http.put<IResponse<boolean>>(
        `${this._baseUrl}/dislike/${id}`,
        {},
        { params: { isSilent: true, isQrCode } },
      ),
    );
  }

  likeCheck(id: string, isQrCode: boolean) {
    return _fvf(
      this.http.get<IResponse<boolean>>(`${this._baseUrl}/is-liked/${id}`, {
        params: { isSilent: true, isQrCode },
      }),
    );
  }

  addComment(id: string, obj: any, isQrCode: boolean) {
    return _fvf(
      this.http.post<IResponse<ILandingPostCommentActivityPublic>>(
        `${this._baseUrl}/comment/${id}`,
        obj,
        { params: { isQrCode } },
      ),
    );
  }

  getComments(id: string, lastCommentNumbering: number, isQrCode: boolean) {
    return _fvf(
      this.http.get<IResponse<ILandingPostCommentActivityPublic[]>>(
        `${this._baseUrl}/comment/${id}/${lastCommentNumbering}`,
        { params: { isSilent: true, isQrCode } },
      ),
    );
  }

  likeComment(id: string, commentId: string, isQrCode: boolean) {
    return _fvf(
      this.http.put<IResponse<ILandingPostCommentActivityPublic>>(
        `${this._baseUrl}/comment/${id}/${commentId}/like`,
        {},
        { params: { isSilent: true, isQrCode } },
      ),
    );
  }

  dislikeComment(id: string, commentId: string, isQrCode: boolean) {
    return _fvf(
      this.http.put<IResponse<ILandingPostCommentActivityPublic>>(
        `${this._baseUrl}/comment/${id}/${commentId}/dislike`,
        {},
        { params: { isSilent: true, isQrCode } },
      ),
    );
  }

  reportPost(id: string, isQrCode: boolean, body: any) {
    return _fvf(
      this.http.post<IResponse<any>>(`${this._baseUrl}/report/${id}`, body, {
        params: { isQrCode },
      }),
    );
  }

  saveVisitor(id: string, isQrCode: boolean, userId?: string) {
    //Add referer if not current domain
    let headers = new HttpHeaders();
    if (document.referrer && document.referrer !== document.location.href) {
      headers = headers.set('origin-referer', document.referrer);
    }
    return _fvf(
      this.http.post<IResponse<string>>(
        `${this._baseUrl}/visitor/${id}/${userId}`,
        {},
        {
          params: { isSilent: true, isQrCode },
          headers: headers,
        },
      ),
    );
  }
}
